<template>
  <b-modal
    id="interest-rate-edit-modal"
    ref="modal-interest-rate-edit"
    centered
    :title="$t('DEBTIA_INTEREST_RATE_TITLE')"
    :no-close-on-backdrop="true"
    :ok-title="$t('DEBTIA_SAVE')"
    size="lg"
    cancel-variant="outline-secondary"
    @ok="handleOk"
    @cancel="resetModal"
    @close="resetModal"
  >
    <b-overlay
      id="overlay-background"
      :show="BModalLoader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-table
        ref="roles"
        class="position-relative"
        responsive
        :fields="tableFields"
        :items="selectedDocumentData"
      >
        <template #cell(title)="data">
          {{ data.item.title }}
        </template>
        <template #cell(payment_amount)="data">
          {{ (data.item.payment_amount) ? data.item.payment_amount : 'N/A' }}
        </template>
        <template #cell(vat_amount)="data">
          {{ data.item.vat_amount }}
        </template>
        <template #cell(interest_rate_percentage)="data">
          <div v-if="data.item.category === 'Base Documents'">
            {{ (data.item.interest_rate_agreed) ? data.item.interest_rate_percentage + '%' : data.item.interest_rate_percentage + '% standard process rente' }}
          </div>
          <div v-else>
            -
          </div>
        </template>
      </b-table>
      <b-alert
        v-if="errorMsg"
        variant="warning"
        show
      >
        <div class="alert-body">
          <span>{{ errorMsg }}</span>
        </div>
      </b-alert>
      <div class="d-flex align-items-start">
        <b-form>
          <b-row>
            <b-col
              cols="12"
              class="text-left"
            >
              <b-row>
                <b-col
                  md="6"
                  class="pt-0 pl-1 pr-1"
                >
                  <b-form-group
                    :label="$t('DEBTIA_CUSTOM_INTEREST_RATE')"
                  >
                    <b-input-group append="%">
                      <b-form-input
                        v-model="interestRate"
                        type="number"
                        :min="0"
                      />
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    label-cols="12"
                  >
                    <b-form-checkbox
                      id="interest_rate_check"
                      v-model="defaultInterestRateCheck"
                    >
                      {{ $t('DEBTIA_DEFUALT_INTEREST_RATE_CHECK') }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput, BTable, BCol, BRow, BFormCheckbox, BAlert, BInputGroup, BOverlay,
} from 'bootstrap-vue'
import i18n from '@/libs/i18n'
import constants from '@/app-configs/constants'
import axios from 'axios'
import { EventBus } from '@/event-bus'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BTable,
    BCol,
    BRow,
    BAlert,
    BFormCheckbox,
    BInputGroup,
    BOverlay,
  },
  props: {
    selectedDocumentData: {
      type: Array,
      required: true,
    },
    getDocuments: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      interestRate: '',
      defaultInterestRateCheck: false,
      caseId: this.$route.params.id,
      errorMsg: '',
      BModalLoader: false,
    }
  },
  computed: {
    tableFields() {
      return [
        { key: 'title', label: i18n.t('DEBTIA_TITLE') },
        { key: 'payment_amount', label: i18n.t('DEBTIA_PAYMENT_AMOUNT') },
        { key: 'vat_amount', label: i18n.t('DEBTIA_VAT_AMOUNT') },
        { key: 'interest_rate_percentage', label: i18n.t('DEBTIA_INTEREST_RATE') },
      ]
    },
  },
  watch: {
    interestRate(value) {
      if (value !== 0) {
        this.defaultInterestRateCheck = false
      }
    },
    defaultInterestRateCheck() {
      if (this.defaultInterestRateCheck) {
        this.interestRate = ''
      }
    },
  },
  methods: {
    async handleOk(e) {
      e.preventDefault()
      if (!this.defaultInterestRateCheck && this.interestRate === '') {
        this.errorMsg = i18n.t('DEBTIA_INTEREST_RATE_ERROR')
        return
      }
      const obj = {
        debt_case_id: this.caseId,
        debt_case_document_id: this.selectedDocumentData[0].id,
        default_interest_rate: this.defaultInterestRateCheck,
        interest_rate_percentage: this.interestRate,
      }
      const token = localStorage.getItem('accessToken')
      this.BModalLoader = true
      const url = `${constants.baseUrl}/base-documents/update`
      await axios.post(url, obj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(response => {
        if (response.status === 200) {
          EventBus.$emit('refreshLogs')
          this.$root.$emit('bv::hide::modal', 'interest-rate-edit-modal')
          this.interestRate = ''
          this.defaultInterestRateCheck = false
          this.errorMsg = ''
          this.BModalLoader = false
          this.getDocuments()
          this.$swal({
            icon: 'success',
            title: 'Updated!',
            text: response.data.message,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        } else {
          this.BModalLoader = false
          this.errorMsg = response.data.message
        }
      }).catch(error => {
        this.BModalLoader = false
        this.errorMsg = error.response.data.message
      })
    },
    async openLink(href) {
      window.open(href, '_blank')
    },
    resetModal() {
      this.interestRate = 0
      this.defaultInterestRateCheck = false
      this.errorMsg = ''
    },
  },
}
</script>
